module.exports = __webpack_public_path__ + "fonts/fa-regular-400.1f77739c.ttf";